"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDateTimeFormat = void 0;
var tslib_1 = require("tslib");
var isEqual_1 = (0, tslib_1.__importDefault)(require("lodash/fp/isEqual"));
var cond_1 = (0, tslib_1.__importDefault)(require("lodash/fp/cond"));
var stubTrue_1 = (0, tslib_1.__importDefault)(require("lodash/fp/stubTrue"));
exports.getDateTimeFormat = (0, cond_1.default)([
    [
        function (plxFormat) { return (0, isEqual_1.default)(plxFormat, 'd'); },
        function () {
            return {
                dateFormat: 'M/d/yyyy',
                timeFormat: '',
            };
        },
    ],
    [
        function (plxFormat) { return (0, isEqual_1.default)(plxFormat, 'D'); },
        function () {
            return {
                dateFormat: 'eeee, MMMM dd, yyyy',
                timeFormat: '',
            };
        },
    ],
    [
        function (plxFormat) { return (0, isEqual_1.default)(plxFormat, 'M'); },
        function () {
            return {
                dateFormat: 'MMMM d',
                timeFormat: '',
            };
        },
    ],
    [
        function (plxFormat) { return (0, isEqual_1.default)(plxFormat, 'Y'); },
        function () {
            return {
                dateFormat: 'MMMM yyyy',
                timeFormat: '',
            };
        },
    ],
    [
        function (plxFormat) { return (0, isEqual_1.default)(plxFormat, 'yy'); },
        function () {
            return {
                dateFormat: 'yy',
                timeFormat: '',
            };
        },
    ],
    [
        function (plxFormat) { return (0, isEqual_1.default)(plxFormat, 'yyyy'); },
        function () {
            return {
                dateFormat: 'yyyy',
                timeFormat: '',
            };
        },
    ],
    [
        function (plxFormat) { return (0, isEqual_1.default)(plxFormat, 'MMM-yyyy'); },
        function () {
            return {
                dateFormat: 'MMM-yyyy',
                timeFormat: '',
            };
        },
    ],
    [
        function (plxFormat) { return (0, isEqual_1.default)(plxFormat, 'MMM/yyyy'); },
        function () {
            return {
                dateFormat: 'MMM/yyyy',
                timeFormat: '',
            };
        },
    ],
    [
        function (plxFormat) { return (0, isEqual_1.default)(plxFormat, 'M-yy'); },
        function () {
            return {
                dateFormat: 'M-yy',
                timeFormat: '',
            };
        },
    ],
    [
        function (plxFormat) { return (0, isEqual_1.default)(plxFormat, 'MM/yyyy'); },
        function () {
            return {
                dateFormat: 'MM/yyyy',
                timeFormat: '',
            };
        },
    ],
    [
        function (plxFormat) { return (0, isEqual_1.default)(plxFormat, 'MM/d/yyyy'); },
        function () {
            return {
                dateFormat: 'MM/d/yyyy',
                timeFormat: '',
            };
        },
    ],
    [
        function (plxFormat) { return (0, isEqual_1.default)(plxFormat, 'd/M/yy'); },
        function () {
            return {
                dateFormat: 'd/M/yy',
                timeFormat: '',
            };
        },
    ],
    [
        function (plxFormat) { return (0, isEqual_1.default)(plxFormat, 'dd/M/yy'); },
        function () {
            return {
                dateFormat: 'dd/M/yy',
                timeFormat: '',
            };
        },
    ],
    [
        function (plxFormat) { return (0, isEqual_1.default)(plxFormat, 'dddd'); },
        function () {
            return {
                dateFormat: 'eeee',
                timeFormat: '',
            };
        },
    ],
    [
        function (plxFormat) { return (0, isEqual_1.default)(plxFormat, 'dddd d-MMM-yyyy'); },
        function () {
            return {
                dateFormat: 'eeee d-MMM-yyyy',
                timeFormat: '',
            };
        },
    ],
    [
        function (plxFormat) { return (0, isEqual_1.default)(plxFormat, 'f'); },
        function () {
            return {
                dateFormat: 'eeee, MMMM dd, yyyy',
                timeFormat: 'h:m:s',
            };
        },
    ],
    [
        function (plxFormat) { return (0, isEqual_1.default)(plxFormat, 'F'); },
        function () {
            return {
                dateFormat: 'eeee, MMMM dd, yyyy',
                timeFormat: 'h:m:ss a',
            };
        },
    ],
    [
        function (plxFormat) { return (0, isEqual_1.default)(plxFormat, 'g'); },
        function () {
            return {
                dateFormat: 'M/d/yyyy',
                timeFormat: 'h:m a',
            };
        },
    ],
    [
        function (plxFormat) { return (0, isEqual_1.default)(plxFormat, 'G'); },
        function () {
            return {
                dateFormat: 'M/d/yyyy',
                timeFormat: 'h:m:ss a',
            };
        },
    ],
    [
        function (plxFormat) { return (0, isEqual_1.default)(plxFormat, 's'); },
        function () {
            return {
                dateFormat: 'M/d/yyyy',
                timeFormat: 'h:m a',
            };
        },
    ],
    [
        function (plxFormat) { return (0, isEqual_1.default)(plxFormat, 't'); },
        function () {
            return {
                dateFormat: '',
                timeFormat: 'h:m a',
            };
        },
    ],
    [
        function (plxFormat) { return (0, isEqual_1.default)(plxFormat, 'T'); },
        function () {
            return {
                dateFormat: '',
                timeFormat: 'h:m:ss a',
            };
        },
    ],
    [
        function (plxFormat) { return (0, isEqual_1.default)(plxFormat, 'h:m'); },
        function () {
            return {
                dateFormat: '',
                timeFormat: 'h:m',
            };
        },
    ],
    [
        function (plxFormat) { return (0, isEqual_1.default)(plxFormat, 'hh:mm'); },
        function () {
            return {
                dateFormat: '',
                timeFormat: 'hh:mm',
            };
        },
    ],
    [
        function (plxFormat) { return (0, isEqual_1.default)(plxFormat, 'hh:mm tt'); },
        function () {
            return {
                dateFormat: '',
                timeFormat: 'hh:mm',
            };
        },
    ],
    [
        function (plxFormat) { return (0, isEqual_1.default)(plxFormat, 'hh:mm t'); },
        function () {
            return {
                dateFormat: '',
                timeFormat: 'hh:mm',
            };
        },
    ],
    [
        function (plxFormat) { return (0, isEqual_1.default)(plxFormat, 'H:mm'); },
        function () {
            return {
                dateFormat: '',
                timeFormat: 'H:mm',
            };
        },
    ],
    [
        function (plxFormat) { return (0, isEqual_1.default)(plxFormat, 'HH:mm'); },
        function () {
            return {
                dateFormat: '',
                timeFormat: 'HH:mm',
            };
        },
    ],
    [
        function (plxFormat) { return (0, isEqual_1.default)(plxFormat, 'hh:mm:ss'); },
        function () {
            return {
                dateFormat: '',
                timeFormat: 'hh:mm:ss',
            };
        },
    ],
    [
        function (plxFormat) { return (0, isEqual_1.default)(plxFormat, 'yyyy-MMM-dd dd:mm:ss'); },
        function () {
            return {
                dateFormat: 'yyyy-MMM-dd',
                timeFormat: 'hh:mm:ss',
            };
        },
    ],
    [
        stubTrue_1.default,
        function () {
            return {
                dateFormat: 'P',
                timeFormat: 'pp',
            };
        },
    ],
]);
